import React, { useState } from 'react';
import DashBoardImg from './Image/DashBoard.png';
import ChecklistImg from './Image/Checklist.png';
import ModalImg from './Image/modal.png';
import EmailImg from './Image/Email.png';
import { 
  CheckCircleIcon, 
  ShieldCheckIcon, 
  DocumentCheckIcon, 
  UserGroupIcon, 
  ArrowRightIcon, 
  Bars3Icon,
  XMarkIcon,
  SparklesIcon,
  BoltIcon,
  PaperAirplaneIcon,
  CloudArrowUpIcon,
  ClipboardDocumentCheckIcon,
  LanguageIcon,
  FunnelIcon // Added for the new section
} from '@heroicons/react/24/outline';

const LandingPage = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="font-sans text-slate-900 bg-white">
      
      {/* --- NAVIGATION --- */}
      <nav className="fixed w-full z-50 bg-white/80 backdrop-blur-lg transition-all duration-300">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-20 items-center">
            {/* Logo */}
            <div className="flex items-center gap-2.5">
              <div className="w-9 h-9 bg-gradient-to-br from-sky-400 to-sky-600 rounded-xl flex items-center justify-center text-white shadow-lg shadow-sky-200">
                <DocumentCheckIcon className="h-5 w-5" />
              </div>
              <span className="font-extrabold text-xl tracking-tight text-slate-900">ImmiSpace</span>
            </div>

            {/* Desktop Links */}
            <div className="hidden md:flex items-center gap-8">
              <a href="#features" className="text-sm font-semibold text-slate-600 hover:text-sky-600 transition-colors">Features</a>
              <a href="#pricing" className="text-sm font-semibold text-slate-600 hover:text-sky-600 transition-colors">Pricing</a>
              <div className="h-5 w-px bg-slate-200"></div>
              <a href="/login" className="text-sm font-bold text-slate-700 hover:text-sky-700 transition-colors">Log In</a>
              <a href="/register" className="bg-sky-600 hover:bg-sky-700 text-white px-6 py-2.5 rounded-xl text-sm font-bold shadow-xl shadow-sky-600/25 transition-all transform hover:-translate-y-0.5 hover:shadow-sky-600/35">
                Start for Free
              </a>
            </div>

            {/* Mobile Menu Button */}
            <div className="md:hidden">
              <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="text-slate-600 p-2">
                {mobileMenuOpen ? <XMarkIcon className="h-6 w-6"/> : <Bars3Icon className="h-6 w-6"/>}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu Dropdown */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-white absolute w-full px-6 py-6 space-y-4 shadow-2xl animate-fade-in-down">
            <a href="#features" className="block text-lg font-medium text-slate-600">Features</a>
            <a href="#pricing" className="block text-lg font-medium text-slate-600">Pricing</a>
            <hr className=""/>
            <a href="/login" className="block text-lg font-bold text-slate-900">Log In</a>
            <a href="/register" className="block w-full text-center bg-sky-600 hover:bg-sky-700 text-white px-5 py-4 rounded-xl font-bold shadow-lg shadow-sky-600/30 transition-colors">Start for Free</a>
          </div>
        )}
      </nav>

      {/* --- HERO SECTION --- */}
      <section className="pt-32 pb-24 lg:pt-48 lg:pb-40 relative overflow-hidden">
        {/* Background "Magic" (Grid + Gradient) */}
        <div className="absolute inset-0 z-0">
            <div className="absolute inset-0 bg-[linear-gradient(to_right,#f1f5f9_1px,transparent_1px),linear-gradient(to_bottom,#f1f5f9_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)]"></div>
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl bg-sky-50/50 blur-3xl rounded-full opacity-50 pointer-events-none"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center max-w-4xl mx-auto">
            
            {/* Trust Badge */}
{/*             <div className="inline-flex items-center gap-2 bg-white text-slate-600 px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wide mb-8 shadow-sm transition-colors cursor-default">
              <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></span>
              Built by an RCIC for RCICs
            </div> */}
            
            {/* HEADLINE */}
            <h1 className="text-5xl lg:text-7xl font-black text-slate-900 tracking-tight leading-[1.1] mb-8">
              Document Collection <br className="hidden md:block" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-sky-600 via-indigo-600 to-sky-600 animate-gradient-x">for Canadian Immigration.</span>
            </h1>
            
            <p className="text-lg lg:text-xl text-slate-500 mb-10 max-w-2xl mx-auto leading-relaxed">
              ImmiSpace automates your document intake and reminders, ensuring your files are always submission-ready.
            </p>
            
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a href="/register" className="w-full sm:w-auto bg-sky-600 hover:bg-sky-700 text-white px-8 py-4 rounded-2xl font-bold text-lg shadow-2xl shadow-sky-600/30 transition-all transform hover:-translate-y-1 hover:shadow-sky-600/40 flex items-center justify-center gap-3">
                Start for Free
                <ArrowRightIcon className="h-5 w-5" />
              </a>
            </div>
            
            {/* BILINGUAL BADGE & SUBTEXT */}
            <div className="mt-6 flex flex-col md:flex-row items-center justify-center gap-3 text-sm text-slate-500">
                <span className="font-medium">No credit card required</span>
                <span className="hidden md:block text-slate-300">•</span>
                <span className="flex items-center gap-1.5 bg-slate-100 px-2 py-0.5 rounded text-slate-600 font-medium">
                    <LanguageIcon className="h-4 w-4" /> 
                    Serve clients in English & Français 🇨🇦
                </span>
            </div>
          </div>

          {/* Hero Image */}
          <div className="mt-16 lg:mt-24 relative mx-auto max-w-6xl group">
            <div className="absolute -inset-1 bg-gradient-to-r from-sky-400 to-indigo-400 rounded-2xl blur opacity-20 group-hover:opacity-40 transition duration-1000 group-hover:duration-200"></div>
            
            <div className="relative rounded-2xl shadow-2xl bg-white p-2 lg:p-4">
                <div className="rounded-xl overflow-hidden aspect-[16/9] relative">
                    <img
                        src={DashBoardImg}
                        alt="ImmiSpace Dashboard"
                        className="w-full h-full object-cover object-top"
                    />
                </div>
            </div>
            
          </div>
        </div>
      </section>

      {/* --- SOCIAL PROOF --- */}
      <section className="py-10 bg-slate-50/50">
        <div className="max-w-7xl mx-auto px-4 text-center">
            <p className="text-sm font-bold text-slate-400 uppercase tracking-widest mb-6">Built on Secure Infrastructure</p>
            <div className="flex flex-wrap justify-center gap-8 md:gap-16 opacity-60 grayscale hover:grayscale-0 transition-all duration-500">
                <div className="flex items-center gap-2 text-xl font-bold text-slate-600"><ShieldCheckIcon className="h-6 w-6"/> Secure Data Privacy</div>
                <div className="flex items-center gap-2 text-xl font-bold text-slate-600"><ShieldCheckIcon className="h-6 w-6"/> Enterprise-Grade Infrastructure</div>
                <div className="flex items-center gap-2 text-xl font-bold text-slate-600">AES-256 Encryption</div>
            </div>
        </div>
      </section>

      {/* --- HOW IT WORKS --- */}
      <section className="py-24 bg-white" id="how-it-works">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-20">
                <h2 className="text-3xl font-extrabold text-slate-900">A smarter workflow.</h2>
                <p className="text-slate-500 mt-2 max-w-2xl mx-auto">ImmiSpace handles the administrative friction so you can focus on the legal strategy.</p>
            </div>
            
            <div className="grid md:grid-cols-3 gap-12 relative">
                <div className="hidden md:block absolute top-16 left-[20%] right-[20%] h-0.5 bg-slate-100 -z-10"></div>

                <div className="relative group text-center">
                    <div className="w-20 h-20 mx-auto bg-white rounded-2xl shadow-lg flex items-center justify-center mb-8 group-hover:scale-110 transition-transform duration-300 relative z-10">
                        <PaperAirplaneIcon className="h-10 w-10 text-sky-600" />
                        <div className="absolute -top-2 -right-2 w-8 h-8 bg-slate-900 rounded-full text-white flex items-center justify-center font-bold text-sm border-4 border-white">1</div>
                    </div>
                    <h3 className="text-xl font-bold text-slate-900 mb-3">Smart Intake</h3>
                    <p className="text-slate-500 leading-relaxed text-sm">
                        Select a program (e.g., Express Entry, Study Permit). ImmiSpace instantly generates the correct, mandatory checklist for your client.
                    </p>
                </div>

                <div className="relative group text-center">
                    <div className="w-20 h-20 mx-auto bg-white rounded-2xl shadow-lg flex items-center justify-center mb-8 group-hover:scale-110 transition-transform duration-300 relative z-10">
                        <CloudArrowUpIcon className="h-10 w-10 text-indigo-600" />
                        <div className="absolute -top-2 -right-2 w-8 h-8 bg-slate-900 rounded-full text-white flex items-center justify-center font-bold text-sm border-4 border-white">2</div>
                    </div>
                    <h3 className="text-xl font-bold text-slate-900 mb-3">Secure Client Portal</h3>
                    <p className="text-slate-500 leading-relaxed text-sm">
                        Your client receives a secure link to a portal in <strong>English or French</strong>.
                    </p>
                </div>

                <div className="relative group text-center">
                    <div className="w-20 h-20 mx-auto bg-white rounded-2xl shadow-lg flex items-center justify-center mb-8 group-hover:scale-110 transition-transform duration-300 relative z-10">
                        <ClipboardDocumentCheckIcon className="h-10 w-10 text-emerald-600" />
                        <div className="absolute -top-2 -right-2 w-8 h-8 bg-slate-900 rounded-full text-white flex items-center justify-center font-bold text-sm border-4 border-white">3</div>
                    </div>
                    <h3 className="text-xl font-bold text-slate-900 mb-3">One-Click Review</h3>
                    <p className="text-slate-500 leading-relaxed text-sm">
                        Approve valid documents or request corrections instantly. <strong>The system automatically chases late items so you don't have to.</strong>
                    </p>
                </div>
            </div>
        </div>
      </section>

      {/* --- FEATURES GRID (UPDATED WITH GATEKEEPER) --- */}
      <section id="features" className="py-24 bg-slate-50 relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
            
            {/* Feature 1: Checklists */}
            <div className="grid lg:grid-cols-[2fr_3fr] md:grid-cols-2 gap-12 lg:gap-20 items-center mb-24">
                <div className="order-2 md:order-1">
                    <div className="inline-block p-3 rounded-2xl bg-purple-100 text-purple-600 mb-6"><SparklesIcon className="h-6 w-6"/></div>
                    <h2 className="text-3xl font-extrabold text-slate-900 mb-4">Launch perfect applications <span className="text-purple-600">in seconds</span>.</h2>
                    <p className="text-lg text-slate-500 mb-8 leading-relaxed">
                    Stop building checklists from scratch. Select a stream, and ImmiSpace instantly generates a comprehensive, regulation-ready document list for your client.
                    </p>
                    <ul className="space-y-4">
                        <li className="flex items-center gap-3 text-slate-700 font-medium"><CheckCircleIcon className="h-5 w-5 text-purple-600"/> Library of templates for major IRCC streams (PR, Study, Work)</li>
                        <li className="flex items-center gap-3 text-slate-700 font-medium"><CheckCircleIcon className="h-5 w-5 text-purple-600"/> Clearly define mandatory requirements vs. optional supporting docs</li>
                        <li className="flex items-center gap-3 text-slate-700 font-medium"><CheckCircleIcon className="h-5 w-5 text-purple-600"/> Fully customizable for complex cases </li>
                    </ul>
                </div>
                <div className="order-1 md:order-2 bg-white p-2 rounded-2xl shadow-xl transition-transform duration-500 min-h-[420px] flex items-stretch">
                    <img src={ChecklistImg} alt="Checklist feature" className="rounded-xl w-full object-cover object-top" />
                </div>
            </div>

            {/* Feature 2: Automation */}
            <div className="grid lg:grid-cols-[3fr_2fr] md:grid-cols-2 gap-12 lg:gap-20 items-center mb-24">
                <div className="bg-white p-2 rounded-2xl shadow-xl transition-transform duration-500 min-h-[420px] flex items-stretch">
                    <img src={EmailImg} alt="Automated email notification" className="rounded-xl w-full object-contain" />
                </div>
                <div>
                    <div className="inline-block p-3 rounded-2xl bg-sky-100 text-sky-600 mb-6"><BoltIcon className="h-6 w-6"/></div>
                    <h2 className="text-3xl font-extrabold text-slate-900 mb-4">Stop chasing, <span className="text-sky-600">start automating.</span></h2>
                    <p className="text-lg text-slate-500 mb-8 leading-relaxed">
                    ImmiSpace performs a real-time gap analysis on every file. If a deadline is due, the system automatically notifies the client with a detailed list of exactly which documents are missing.
                    </p>
                    <ul className="space-y-4">
                        <li className="flex items-center gap-3 text-slate-700 font-medium"><CheckCircleIcon className="h-5 w-5 text-sky-600"/> Automatic reminders for clients</li>
                        <li className="flex items-center gap-3 text-slate-700 font-medium"><CheckCircleIcon className="h-5 w-5 text-sky-600"/> Lists exactly what is missing</li>
                        <li className="flex items-center gap-3 text-slate-700 font-medium"><CheckCircleIcon className="h-5 w-5 text-sky-600"/> No more manual follow-up emails</li>
                    </ul>
                </div>
            </div>

            {/* Feature 3: The Gatekeeper (NEW) */}
            <div className="grid lg:grid-cols-[2fr_3fr] md:grid-cols-2 gap-12 lg:gap-20 items-center">
                <div className="order-2 md:order-1">
                    <div className="inline-block p-3 rounded-2xl bg-emerald-100 text-emerald-600 mb-6"><FunnelIcon className="h-6 w-6"/></div>
                    <h2 className="text-3xl font-extrabold text-slate-900 mb-4">Never open an incomplete file <span className="text-emerald-600">again.</span></h2>
                    <p className="text-lg text-slate-500 mb-8 leading-relaxed">
                        Reviewing half-finished applications is a waste of time. Your new workflow is simple: only check the 'Complete Files' section. We filter out the noise so you only spend time on applications that are 100% ready for review.
                    </p>
                    <ul className="space-y-4">
                        <li className="flex items-center gap-3 text-slate-700 font-medium"><CheckCircleIcon className="h-5 w-5 text-emerald-600"/> Dedicated section for finished work</li>
                        <li className="flex items-center gap-3 text-slate-700 font-medium"><CheckCircleIcon className="h-5 w-5 text-emerald-600"/> Automatic "100% Ready" status flags</li>
                        <li className="flex items-center gap-3 text-slate-700 font-medium"><CheckCircleIcon className="h-5 w-5 text-emerald-600"/> Zero time spent on partial submissions</li>
                    </ul>
                </div>
                <div className="order-1 md:order-2 bg-white p-2 rounded-2xl shadow-xl transition-transform duration-500 min-h-[420px] flex items-stretch">
                    <img src={ModalImg} alt="Complete file modal" className="rounded-xl w-full object-contain" />
                </div>
            </div>

        </div>
      </section>

      {/* --- PRICING --- */}
      <section className="py-24 bg-slate-900 text-white relative overflow-hidden" id="pricing">
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-20">
            <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-sky-600 blur-[100px]"></div>
            <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] rounded-full bg-indigo-600 blur-[100px]"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
            <div className="text-center mb-16">
                <h2 className="text-3xl lg:text-5xl font-black mb-6">Simple, Fair Pricing</h2>
                <p className="text-slate-300 text-lg max-w-xl mx-auto">No complex tiers. No hidden fees. <br/>Just one tool to save you hours every week.</p>
            </div>

            <div className="flex flex-col md:flex-row justify-center gap-8 max-w-4xl mx-auto">
                {/* Free Plan */}
                <div className="bg-white/5 p-10 rounded-3xl w-full md:w-1/2 hover:bg-white/10 transition-colors backdrop-blur-sm">
                    <div className="text-sm font-bold text-sky-400 uppercase tracking-wider mb-2">Starter</div>
                    <div className="text-5xl font-black mb-6">$0 <span className="text-lg text-slate-400 font-normal">/ forever</span></div>
                    <p className="text-slate-300 mb-8 pb-8 leading-relaxed">Perfect for testing the platform with your first file.</p>
                    <ul className="space-y-4 mb-10">
                        <li className="flex items-center gap-3 text-slate-200"><CheckCircleIcon className="h-5 w-5 text-sky-500 shrink-0"/> 1 Active Client</li>
                        <li className="flex items-center gap-3 text-slate-200"><CheckCircleIcon className="h-5 w-5 text-sky-500 shrink-0"/> All Checklists Included</li>
                        <li className="flex items-center gap-3 text-slate-200"><CheckCircleIcon className="h-5 w-5 text-sky-500 shrink-0"/> 500MB Storage</li>
                    </ul>
                    <a href="/register" className="block text-center bg-white text-slate-900 py-4 rounded-xl font-bold hover:bg-slate-100 transition-colors">Start for Free</a>
                </div>

                {/* Pro Plan */}
                <div className="bg-gradient-to-br from-sky-600 to-indigo-700 p-10 rounded-3xl w-full md:w-1/2 transform md:scale-105 shadow-2xl shadow-sky-900/50 relative">
                    <div className="absolute top-0 right-0 bg-yellow-400 text-yellow-900 text-xs font-bold px-4 py-1.5 rounded-bl-2xl rounded-tr-2xl shadow-sm">LIMITED OFFER</div>
                    <div className="text-sm font-bold text-white/80 uppercase tracking-wider mb-2">Professional</div>
                    <div className="text-5xl font-black mb-6">$29 <span className="text-lg text-white/60 font-normal">/ month</span></div>
                    <p className="text-white/80 mb-8 pb-8 leading-relaxed">For consultants ready to automate their entire practice.</p>
                    <ul className="space-y-4 mb-10">
                        <li className="flex items-center gap-3 font-medium"><CheckCircleIcon className="h-5 w-5 text-white shrink-0"/> Unlimited Clients</li>
                        <li className="flex items-center gap-3 font-medium"><CheckCircleIcon className="h-5 w-5 text-white shrink-0"/> 10GB Secure Storage</li>
                        <li className="flex items-center gap-3 font-medium"><CheckCircleIcon className="h-5 w-5 text-white shrink-0"/> Priority Support</li>
                        <li className="flex items-center gap-3 font-medium"><CheckCircleIcon className="h-5 w-5 text-white shrink-0"/> 30-Day Money Back Guarantee</li>
                    </ul>
                    <a href="https://docup-visa.com/register" className="block text-center bg-slate-900 text-white py-4 rounded-xl font-bold shadow-lg hover:bg-slate-800 transition-colors">Get Unlimited Access</a>
                </div>
            </div>
        </div>
      </section>

      {/* --- FOOTER --- */}
      <footer className="bg-white pt-16 pb-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid md:grid-cols-4 gap-12 mb-12">
                <div className="col-span-2">
                    <div className="flex items-center gap-2 mb-4">
                        <div className="w-8 h-8 bg-gradient-to-br from-sky-400 to-sky-600 rounded-lg flex items-center justify-center text-white shadow-md shadow-sky-200"><DocumentCheckIcon className="h-4 w-4" /></div>
                        <span className="font-bold text-xl text-slate-900 tracking-tight">ImmiSpace</span>
                    </div>
                    <p className="text-slate-500 text-sm leading-relaxed max-w-xs">
                        The dedicated document management platform for Canadian Immigration Consultants. Secure, simple, and built in Canada.
                    </p>
                </div>
                <div>
                    <h4 className="font-bold text-slate-900 mb-4">Product</h4>
                    <ul className="space-y-2 text-sm text-slate-500">
                        <li><a href="#features" className="hover:text-sky-600 transition-colors">Features</a></li>
                        <li><a href="#pricing" className="hover:text-sky-600 transition-colors">Pricing</a></li>
                        <li><a href="/login" className="hover:text-sky-600 transition-colors">Log In</a></li>
                    </ul>
                </div>
                <div>
                    <h4 className="font-bold text-slate-900 mb-4">Legal</h4>
                    <ul className="space-y-2 text-sm text-slate-500">
                        <li><a href="/terms" className="hover:text-sky-600 transition-colors">Terms of Service</a></li>
                    </ul>
                </div>
            </div>
            <div className="pt-8">
                <p className="text-xs text-slate-400 font-medium">© {new Date().getFullYear()} ImmiSpace. All rights reserved.</p>
            </div>
        </div>
      </footer>

    </div>
  );
};

export default LandingPage;